import { unescape } from "@/components/helpers/string-utils";
import { Media } from "@/components/layout/Media";

import { DesktopNoteEditable } from "./DesktopNoteEditable";
import { MobileNoteEditable } from "./MobileNoteEditable";

interface NoteEditableProps {
  isNew: boolean;
  value: string;
  loading: boolean;
  onSave: () => void;
  onCancel: () => void;
  onChange: (value: string) => void;
}

export function NoteEditable({
  isNew,
  value,
  loading,
  onSave,
  onCancel,
  onChange,
}: NoteEditableProps) {
  return (
    <>
      <Media at="xs">
        <MobileNoteEditable
          isNew={isNew}
          value={unescape(value)}
          loading={loading}
          onSave={onSave}
          onCancel={onCancel}
          onChange={onChange}
        />
      </Media>
      <Media greaterThan="xs">
        <DesktopNoteEditable
          value={unescape(value)}
          loading={loading}
          onSave={onSave}
          onCancel={onCancel}
          onChange={onChange}
        />
      </Media>
    </>
  );
}
